/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowSelectNone
 * @restrict A
 * @description
 * The wcRowSelectNone directive is responsible for un select all the selected rows or headers of the datatable.
 */



angular.module('WcResponsiveTableModule').directive('wcRowSelectNone', function() {
	return {
		restrict: 'A',
		require: ['wcRowSelectNone', '^wcResponsiveTable', '^ngModel'],
		scope: {},
		controllerAs: 'rowSelectNoneController',
		controller: ['$scope', '$element', function ($scope, $element) {
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			this.viewScope = responsiveTableController.WcTableScopeService.getParentScope();

			this.selectNone = function() {
				this.viewScope.$broadcast('table.select.checkbox.none');
				this.viewScope.$broadcast('table.select.button.none');
				$scope.$apply();
			};
		}],
		link: function(scope, element, attrs, controllers) { //jshint unused:true
			var rowSelectNoneController = controllers[0];
			element.on('click', function () {
				rowSelectNoneController.selectNone();
			});
		}
	};
});